import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

import Gallery from "./gallery.jsx";
import Latest from "./latest.jsx";
import History from "./history.jsx";
import RussellPrints from "./russellPrints.jsx";
import galleryData from '../localdata/gallery.json';
import categoryData from '../localdata/categories.json';

const Home = () => {

  return (
    <Container>
        <section id="gallery" className="my-4">
          <Gallery gallery={galleryData} categories={categoryData}/>
        </section>

        <section id="about" className="mt-4 p-4 bg-dark text-white">
          <Row className="my-4">
            <Col className="pb-4" xs={12} sm={6} md={6} lg={3} xl={3}>
              <h4>About Me</h4>
              <p>My name is Ray Russell and I’m a retired professional artist.</p>
              <p>I draw and paint for pleasure, taking inspiration from photographs of people, faces and nature.</p>
              <p><i className="far fa-envelope"></i>&nbsp;&nbsp;<a className="text-link" href="mailto:ray@rayrussellart.com">ray.russell@icloud.com</a></p>
            </Col>       
            <Col className="pb-4" xs={12} sm={6} md={6} lg={3} xl={3}>
              <Image src="/images/atWork1.jpg" alt="Ray at work" rounded fluid />
            </Col>       
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <Latest showcase={galleryData.slice(0,4)} />
            </Col>
          </Row>

          <History />
        </section>

        <section id="rp" className="mt-4">
          <RussellPrints />
        </section>

    </Container>
  );
}

export default Home;
